export interface ChangeRequest {
  id: string;
  documentId: string;
  documentTitle: string;
  documentNumber: string;
  changeReason: string;
  approverId: string;
  approverName: string;
  requestedByUserId: string;
  requestedByName: string;
  requestedAt: string;
  status: 'pending' | 'approved' | 'rejected';
  approverComment?: string;
  resolvedAt?: string;
}

const STORAGE_KEY = 'mock_changeRequests';

function readAll(): ChangeRequest[] {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
  } catch {
    return [];
  }
}

function writeAll(requests: ChangeRequest[]): void {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(requests));
}

// TODO: replace with real API call
export async function createChangeRequest(
  data: Omit<ChangeRequest, 'id' | 'requestedAt' | 'status'>
): Promise<ChangeRequest> {
  const record: ChangeRequest = {
    ...data,
    id: `cr-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`,
    requestedAt: new Date().toISOString(),
    status: 'pending',
  };
  const all = readAll();
  all.unshift(record);
  writeAll(all);
  return record;
}

// TODO: replace with real API call
export async function getAllChangeRequests(): Promise<ChangeRequest[]> {
  return readAll();
}

// TODO: replace with real API call
export async function approveChangeRequest(id: string, comment?: string): Promise<ChangeRequest> {
  const all = readAll();
  const idx = all.findIndex((r) => r.id === id);
  if (idx === -1) throw new Error('Change request not found');
  all[idx] = {
    ...all[idx],
    status: 'approved',
    approverComment: comment,
    resolvedAt: new Date().toISOString(),
  };
  writeAll(all);
  return all[idx];
}

// TODO: replace with real API call
export async function rejectChangeRequest(id: string, comment?: string): Promise<ChangeRequest> {
  const all = readAll();
  const idx = all.findIndex((r) => r.id === id);
  if (idx === -1) throw new Error('Change request not found');
  all[idx] = {
    ...all[idx],
    status: 'rejected',
    approverComment: comment,
    resolvedAt: new Date().toISOString(),
  };
  writeAll(all);
  return all[idx];
}
